export default {
    mpanel: {
        submit: '提出する',
        cancel: '取り消す',
        mpage: {
            total: 'データ',
            page: 'ページ'
        },
        mtable: {
            index: 'シリアル番号',
            actions: '操作する'
        }
    },
    tagsNav: {
        allTags: 'すべてのラベル',
        closeAll: 'すべて閉じる'
    },
    tagsView: {
        refresh: 'Refresh',
        close: 'Close',
        closeOthers: 'Close Others',
        closeAll: 'Close all'
    },
    topHeader: {
        lang: 'JP',
        message: '便り',
        service: 'サービス'
    }
};
